import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  mainContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    // backgroundColor: theme.other.colors.background,
    backgroundColor: 'white',
    color: theme.other.colors.primaryText,
    padding: '44px 0px',
    position: 'relative',
  },
  header: {
    width: '100%',
    height: '100%',
    maxHeight: '54px',
    padding: '12px 20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: theme.other.colors.background,
    position: 'fixed',
    left: 0,
    top: 0,
  },
  progressWrapper: {
    width: '100%',
    height: '100%',
    maxHeight: '16px',
    padding: '0px 16px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.other.colors.background,
    position: 'fixed',
    left: 0,
    top: 54,
  },
  headerText: {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '21px',
    color: theme.other.colors.primaryText,
  },
  contentContainer: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  footer: {
    // position: 'fixed',
    // left: 0,
    // bottom: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '12px 20px',
    // background: theme.other.colors.background,
    borderTop: `1px solid ${theme.other.colors.disabled.subtle}`,
    width: '100%',
    '@media (max-width: 600px)': {
      position: 'static',
      paddingBottom: 0,
    },
  },
  heading: {
    color: theme.other.colors.primaryText,
    marginTop: '12px',
    marginBottom: '9px',
  },
  description: {
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '23px',
    color: theme.other.colors.secondaryText,
    marginBottom: '45px',
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px',
    paddingLeft: '24px',
    width: 'auto',
    background: theme.other.colors.primaryOld,
    borderRadius: '5px',
    border: 'none',
    color: '#ffffff',
    ':hover': {
      cursor: 'pointer',
      background: `${theme.other.colors.primaryHover} !important`,
    },
  },
  iconNextButton: {
    padding: '4px 12px 4px 12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.other.colors.primaryOld,
    borderRadius: '8px',
    '&:disabled': {
      backgroundColor: theme.colors.grey[7],
    },
    ':hover': {
      backgroundColor: `${theme.other.colors.primaryHover} !important`,
    },
  },
  buttonSecondary: {
    background: theme.other.colors.backgroundLight,
    border: `1px solid ${theme.other.colors.primaryOld}`,
    color: '#ffffff',
    ':hover': {
      cursor: 'pointer',
      background: `${theme.other.colors.primaryHover} !important`,
    },
  },
}));

export const useCommonStyles = () => {
  const data = useStyles();
  return { ...data, commonClasses: data.classes };
};

export default useCommonStyles;
